import {type ReactNode, useState} from 'react'
import {Box, Button, Card, Collapse} from '@mantine/core'
import {mobileBreakpoint} from '../../theme.tsx'
import {IconChevronDown, IconChevronUp} from '@tabler/icons-react'

type Props = {
  mainControls: ReactNode
  secondaryControls?: ReactNode
}

export const FilterBar = ({mainControls, secondaryControls}: Props) => {
  const [expanded, setExpanded] = useState<boolean>(false)

  return (
    <Card style={{flex: 1, gap: 0}}>
      {/* Desktop */}
      <Box visibleFrom={mobileBreakpoint} style={{display: 'flex', flexDirection: 'row', gap: 25}}>
        {mainControls}
        {secondaryControls}
      </Box>

      {/* Mobile */}
      <Box hiddenFrom={mobileBreakpoint} style={{display: 'flex', flexDirection: 'column', gap: 15}}>
        {mainControls}

        <Button
          hiddenFrom={mobileBreakpoint}
          variant={'transparent'}
          size={'compact-sm'}
          onClick={() => setExpanded((expanded) => !expanded)}
          rightSection={expanded ? <IconChevronDown stroke={1} /> : <IconChevronUp stroke={1} />}
        >
          Additional options
        </Button>
        <Collapse expanded={expanded}>
          <Box style={{display: 'flex', flexDirection: 'column', gap: 15}}>{secondaryControls}</Box>
        </Collapse>
      </Box>
    </Card>
  )
}
